export default __webpack_public_path__ + "static/N0021-3c3f620cc42d832d9a33e4e9eaba5c75.png";